import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './App';
import {AuthService} from './Services';
import ConfigService from './Services/ConfigService';
import {LoaderStore} from './Stores/LoaderStore';
import dxConfig from 'devextreme/core/config';
import {licenseKey} from './devextreme-license';
import {BrowserRouter} from "react-router-dom";

dxConfig({licenseKey});

if (typeof window !== "undefined") {
    (window as any).DevExpress = (window as any).DevExpress || {};
    (window as any).DevExpress.config = {
        licenseKey
    };
}

const rootEl = document.getElementById('root');
export const loaderStore = new LoaderStore();
export const config = ConfigService.getConfig();
export const authService = new AuthService();

const renderCallback = () => {
    const loader = document.getElementById('react-app-loader');
    if (loader) {
        loaderStore.appLoaderElement = loader;
        loader.addEventListener('transitionend', () => {
            if (loader.classList.contains('hide')) {
                loader.classList.add('invisible');
            }
        }, true);
        loaderStore.hideAppLoader(true);
        authService.init();
    }
};

window.addEventListener('load', async () => {
    if (navigator.serviceWorker) {
        try {
            const reg = await navigator.serviceWorker.register('./sw.js');
            console.log('SW:Registration successful with scope: ', reg.scope);
        } catch (e) {
            console.log('SW:Registration failed: ', e);
        }
    }
});

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>,
    rootEl,
    renderCallback
);
